<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <p class="hint">
      退货退款流程中，买家已通过预约寄件支付退货运费，卖家责任订单须在确认收货前支付应承担部分；支付后系统自动原路退回买家。可发送站内「通知消息」催付。
    </p>

    <div class="toolbar">
      <el-input
        v-model="orderNoKeyword"
        placeholder="订单号（模糊）"
        clearable
        size="small"
        style="width: 240px; margin-right: 8px"
        @keyup.enter.native="search"
      />
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button size="small" @click="resetSearch">重置</el-button>
    </div>

    <div class="table-scroll-wrap">
    <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
      <el-table-column prop="pickupOrderId" label="寄件单ID" width="90" align="center" />
      <el-table-column prop="secondhandOrderNo" label="订单号" min-width="170" align="center" show-overflow-tooltip />
      <el-table-column prop="orderId" label="订单ID" width="90" align="center" />
      <el-table-column prop="refundApplyId" label="退款申请ID" width="110" align="center" />
      <el-table-column prop="returnPhase" label="退货阶段" width="90" align="center" />
      <el-table-column label="卖家" min-width="120" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.sellerNickName || "-" }}
          <span v-if="scope.row.sellerUserId" class="uid">({{ scope.row.sellerUserId }})</span>
        </template>
      </el-table-column>
      <el-table-column label="买家" min-width="120" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.buyerNickName || "-" }}
          <span v-if="scope.row.buyerUserId" class="uid">({{ scope.row.buyerUserId }})</span>
        </template>
      </el-table-column>
      <el-table-column label="应付运费(元)" width="110" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.payAmount) }}</template>
      </el-table-column>
      <el-table-column prop="sellerSettleStatus" label="卖家结算" width="100" align="center" />
      <el-table-column label="买家付运费时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.payTime) }}</template>
      </el-table-column>
      <el-table-column label="更新时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.updateTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="sendNotify(scope.row)">发送催付</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  name: "SecondhandSellerReturnFreight",
  data() {
    return {
      historyArr: ["客诉处理", "卖家待付退货运费"],
      loading: false,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      pageSize: 20,
      orderNoKeyword: "",
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    formatMoney(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return Number.isFinite(n) ? n.toFixed(2) : String(v);
    },
    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    search() {
      this.currentPage = 1;
      this.fetchList(1);
    },
    resetSearch() {
      this.orderNoKeyword = "";
      this.currentPage = 1;
      this.fetchList(1);
    },
    changePage(p) {
      this.currentPage = p;
      this.fetchList(p);
    },
    handlePageSizeChange() {
      this.fetchList(1);
    },
    fetchList(page) {
      this.loading = true;
      let url = `${this.$api.api.mgmtSellerReturnFreightUnpaid}?page=${page || 1}&size=${this.pageSize}`;
      const kw = (this.orderNoKeyword || "").trim();
      if (kw) {
        url += `&secondhandOrderNo=${encodeURIComponent(kw)}`;
      }
      this.$https(url, {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sendNotify(row) {
      if (!row || !row.pickupOrderId) return;
      this.$confirm("将向卖家发送站内通知消息催付，是否继续？", "发送催付通知", {
        type: "warning",
      })
        .then(() => {
          const url = `${this.$api.api.mgmtSellerReturnFreightSendNotify}?pickupOrderId=${encodeURIComponent(
            row.pickupOrderId
          )}`;
          return this.$https(url, {}, "POST");
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已发送");
          } else {
            this.$message.error((res.data && res.data.msg) || "发送失败");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}
.toolbar {
  margin-top: 12px;
}
.uid {
  color: #999;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/secondhandSellerReturnFreight/index.vue